import React, { useState } from "react";
import {
  AppBar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  Button,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ItemImageSVG from "./ItemImageSVG";
import GeneratePOPDF_SVG from "./GeneratePOPDF_SVG";
import GMB from "./Gmb";
import GMBSVG from "./GMBSVG";

const drawerWidth = 200;

export default function Sidebar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  //sidebar drawer
  const drawer = (
    <Box
      sx={{
        overflow: "auto",
        padding: 1,
        scrollbarWidth: "none",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          gap: 8,
          backgroundColor: "#FFFFFF",
          borderRadius: "16px",
        }}
      >
        <Button
          variant="outlined"
          style={{
            width: "122px",
            color: "#FFFFFF",
            fontSize: "12px",
            fontWeight: 600,
            alignSelf: "stretch",
            borderColor: "#172128",
            backgroundColor: "#172128",
            borderRadius: "12px",
            padding: "6px",
            gap: "15px",
            alignItems: "center",
          }}
        >
          GMB
        </Button>
        <div
          style={{
            backgroundColor: "#FA4B16",
            width: 48,
            height: 48,
            borderRadius: 12,
            gap: 15,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <GMBSVG />
        </div>
      </div>
      <Typography
        variant="div"
        component="div"
        style={{
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "16px",
          marginTop: 12,
          color: "#808C96",
        }}
      >
        Favourites
      </Typography>
      <List>
        {[
          { name: "Item Images", icon: <ItemImageSVG /> },
          { name: "Generate PO PDF", icon: <GeneratePOPDF_SVG /> },
        ].map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton
              sx={{
                borderRadius: "8px",
                bgcolor: "#F1F6FA",
                mb: 1,
                display: "flex",
                gap: "12px",
              }}
            >
              {item.icon}
              <ListItemText
                sx={{ my: 0 }}
                primary={item.name}
                primaryTypographyProps={{
                  fontSize: 12,
                  fontWeight: 600,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ my: 1 }} />
      <Typography
        variant="div"
        component="div"
        style={{
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "16px",
          color: "#808C96",
        }}
      >
        All Modules
      </Typography>
      <List>
        {["assortment", "indent", "manual TO", "PO Management"].map((text) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              sx={{ borderRadius: "8px", bgcolor: "#F1F6FA", mb: 1 }}
            >
              <ListItemText
                sx={{ my: 0 }}
                primary={text}
                primaryTypographyProps={{
                  fontSize: 12,
                  fontWeight: 600,
                }}
              />
              <ExpandMore />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <div
        style={{
          // margin: 12,
          backgroundColor: "#172128",
          gap: "8px",
          padding: 8,
          borderRadius: "16px",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            padding: 12,
            paddingBottom: 0,
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="div"
            component="div"
            style={{
              color: "#FFFFFF",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "16px",
            }}
          >
            Google My Business
          </Typography>
          <ExpandLess
            sx={{
              color: "#FFFFFF",
              fontSize: "12px",
              fontWeight: 600,
            }}
          />
        </div>
        <Divider style={{ backgroundColor: "#38444C", margin: 12 }} />
        <Button
          variant="outlined"
          style={{
            width: "100%",
            color: "#FFFFFF",
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "16px",
            alignSelf: "stretch",
            borderColor: "#FA4B16",
            backgroundColor: "#FA4B16",
            borderRadius: "12px",
            padding: "12px",
            gap: "12px",
            alignItems: "center",
            textTransform: "none",
          }}
        >
          Profile Management
        </Button>
      </div>
      {/* Menu Item Collection 2 */}
      <div>
        <List>
          {[
            "PBI",
            "Master Data MAn",
            "fusion",
            "auto delisting",
            "more heroes",
            "visibility v2",
            "TOT Portal",
            "vendor portal",
            "benchmarking",
          ].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton
                sx={{
                  borderRadius: "16px",
                  "&:hover": {
                    borderRadius: "16px",
                  },
                  backgroundColor: "#F1F6FA",
                  marginBottom: 1,
                }}
              >
                <ListItemText
                  sx={{ my: 0 }}
                  primary={text}
                  primaryTypographyProps={{
                    fontSize: 12,
                    fontWeight: "600",
                  }}
                />
                <ExpandMore />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </div>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
            
          ml: { md: `${drawerWidth}px` },
          boxShadow: "none",
          bgcolor: "#FFFFFF",
        }}
      >
        <Toolbar sx={{ minHeight: "48px" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 1, display: { md: "none" } }}
          >
            <MenuIcon sx={{ color: "black" }} />
          </IconButton>
          {/* Search bar */}
          <Box
            sx={{
              zIndex: 2,
              display: "flex",
              alignItems: "center",
              bgcolor: "#F1F6FA",
              borderRadius: "32px",
              px: 2,
              width: "100%",
              // maxWidth: "500px",
            }}
          >
            <SearchIcon sx={{ color: "black" }} />
            <input
              type="text"
              placeholder="Search your module"
              style={{
                border: "none",
                backgroundColor: "#F1F6FA",
                outline: "none",
                padding: 8,
                color: "black",
                width: "100%",
              }}
            />
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="sidebar navigation"
      >
        {/* mobile only */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              boxShadow: "none",
            },
          }}
        >
          {drawer}
        </Drawer>
        {/* destop only */}
        <Drawer
          variant="permanent"
          sx={{
            zIndex: 2,
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              boxShadow: "none",
              borderRight: "none",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 2,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <GMB />
      </Box>
    </Box>
  );
}
